import Vue from "vue";
import App from "./App.vue";
import "@/styles/index.scss";
import VueRouter from "vue-router";
import router from "./router";

import ElementUI from "element-ui";
//样式文件需要单独引入
import "element-ui/lib/theme-chalk/index.css";

// RBAC 权限（2026-09-21 新增）
import permDirective from "@/directives/perm";
import {
  restorePermInfo,
  loadPermInfo,
  clearPermInfo,
  hasPerm,
  hasAnyPerm,
  hasAllPerm,
  isPlatformUser,
  orgType,
} from "@/utils/permission";

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(ElementUI);

// v-perm 指令
Vue.directive("perm", permDirective);

// 全局判定方法
Vue.prototype.$hasPerm = hasPerm;
Vue.prototype.$hasPermAny = hasAnyPerm;
Vue.prototype.$hasPermAll = hasAllPerm;
Vue.prototype.$isPlatformUser = isPlatformUser;
Vue.prototype.$orgType = orgType;
Vue.prototype.$loadPermInfo = loadPermInfo;

// 先用本地缓存恢复，避免刷新后首屏闪烁；随后再拉一次最新权限。
// ⚠️ 未登录（无 token）时**不要**请求 /user/permInfo —— 会拿到 501 并被
//    响应拦截器跳登录页，形成「刷新 → 501 → 刷新」的死循环。登录页无任何权限限制。
if (localStorage.getItem("token")) {
  restorePermInfo();
  loadPermInfo();
} else {
  clearPermInfo();
}

new Vue({
  render: (h) => h(App),
  router,
}).$mount("#app");
